import {computed, reactive} from "vue";
import ConnectorComposition from "./ConnectorComposition";
import { ClientJS } from 'clientjs';

const useComment = () => {
  //サーバーと通信用のコンポジションを用意
  const _connector = ConnectorComposition();

  //この composition が扱うデータ
  const state = reactive({
    //コメント
    // content: "すごいです\r\nすごいです\r\nすごいです"
    // created_at: 1678382101
    // delete_type: 0
    // deleted_at: null
    // depth: 1
    // id: 1
    // parent_id: 0
    // post_id: 39
    // updated_at: null
    // user_id: 3
    // user_nickname_id: 0
    comments: [],

    //ログインしているユーザー ID
    userId: 0,

    //投稿 ID
    postId: 0,

    //投稿のニックネーム ID
    postUserNicknameId: 0,

    //共感しているコメント(id の一次元配列)
    commentEmpathy: [],

    //違反報告しているコメント(id の一次元配列)
    commentViolations: [],

    //表示されている投稿が自身の投稿かどうか
    isMyPost: false,

    //投稿がコメントを受け付けているか
    acceptComments: true
  });

  //現在ログインしているかどうか
  const isLogin = computed(() => Number(state.userId) !== 0);

  //サーバーより提供のデータを reactive 化する
  const init = async (comments, commentViolations, userId, postId, postUserNicknameId, isMyPost, acceptComments) => {
    // 初期値挿入
    state.comments = comments;
    state.commentViolations = commentViolations;
    state.userId = userId;
    state.postId = postId;
    state.postUserNicknameId = postUserNicknameId;
    state.isMyPost = isMyPost;
    state.acceptComments = acceptComments;

    // 共感の状態を調べる
    const result = await _connector.connectGet(siteUrl+'/place/get-empathy-by-fingerprint/'+postId+'?fingerprint='+(new ClientJS()).getFingerprint());

    //失敗したら何もしない
    if (result === null || ! result.hasOwnProperty('post') || ! result.hasOwnProperty('comment')) {
      return;
    }

    // 初期値挿入
    state.commentEmpathy = result.comment;
  };

  /**
   * コメントを返す
   * 成功時に null を返す点に注意
   * 失敗時はエラー文字列の一次元配列を返す
   * @param nicknameId
   * @param content
   * @param parent
   * @returns {Promise<[]|null>}
   */
  const setComment = async (nicknameId, content, parent) => {
    //送信 body の作成
    const body = new FormData();
    body.append('content', content);
    body.append('user_nickname_id', nicknameId);

    //サーバーに依頼
    const result = await _connector.connectPost(Number(parent) === 0 ? siteUrl+'/place/set-comment/'+state.postId+'/0' : siteUrl+'/place/set-comment/'+state.postId+'/'+parent, body);

    //失敗したらエラーを返す
    if (result === null) {
      return _connector.errors.value;
    }

    //成功したらコメントを更新
    state.comments = result;

    //成功を返す
    return null;
  };

  /**
   * コメントを削除する
   * 成功時に null を返す点に注意
   * 失敗時はエラー文字列の一次元配列を返す
   * @param nicknameId
   * @param content
   * @param parent
   * @returns {Promise<[]|null>}
   */
  const deleteComment = async (commentId) => {
    //サーバーに依頼
    const result = await _connector.connectPost(siteUrl+'/place/delete-comment/'+commentId);

    //失敗したらエラーを返す
    if (result === null) {
      return _connector.errors.value;
    }

    //成功したらコメントを更新
    state.comments = result;

    //成功を返す
    return null;
  };

  /**
   * 共感をトグルさせる
   * @param booleanValue
   * @returns {Promise<boolean>}
   */
  const toggleCommentEmpathy = async (booleanValue, commentId) => {
    // フィンガープリントを取得
    const body = new FormData();
    body.append('fingerprint', (new ClientJS()).getFingerprint());

    //サーバーに依頼
    const result = await _connector.connectPost(booleanValue ? siteUrl+'/place/set-comment-empathy/'+commentId : siteUrl+'/place/delete-comment-empathy/'+commentId, body);

    //失敗したらメッセージアラートを表示
    if (result === null) {
      //アラート表示
      if ( ! _connector.isDoubleConnectBlock.value) {
        alert(_connector.errors.value.join("\n"));
      }

      //失敗を返す
      return false;
    }

    //成功したらローカルの値も変更する
    if (booleanValue && ! state.commentEmpathy.some(currentId => Number(currentId) === Number(commentId))) {
      state.commentEmpathy.push(Number(commentId));
    }
    else if ( ! booleanValue) {
      const deleteIndex = state.commentEmpathy.findIndex(currentId => Number(currentId) === Number(commentId));
      if (deleteIndex !== -1) {
        state.commentEmpathy.splice(deleteIndex, 1);
      }
    }

    //成功を返す
    return true;
  };

  /**
   * 違反をトグルさせる
   * @param booleanValue
   * @returns {Promise<boolean>}
   */
  const toggleCommentViolation = async (booleanValue, commentId) => {
    //サーバーに依頼
    const result = await _connector.connectPost(booleanValue ? siteUrl+'/place/set-comment-violation/'+commentId : siteUrl+'/place/delete-comment-violation/'+commentId);

    //失敗したらメッセージアラートを表示
    if (result === null) {
      //アラート表示
      if ( ! _connector.isDoubleConnectBlock.value) {
        alert(_connector.errors.value.join("\n"));
      }

      //失敗を返す
      return false;
    }

    //成功したらローカルの値も変更する
    if (booleanValue && ! state.commentViolations.some(currentId => Number(currentId) === Number(commentId))) {
      state.commentViolations.push(Number(commentId));
    }
    else if ( ! booleanValue) {
      const deleteIndex = state.commentViolations.findIndex(currentId => Number(currentId) === Number(commentId));
      if (deleteIndex !== -1) {
        state.commentViolations.splice(deleteIndex, 1);
      }
    }

    //成功を返す
    return true;
  };

  //提供
  return {
    state,
    isLogin,
    init,
    setComment,
    deleteComment,
    toggleCommentEmpathy,
    toggleCommentViolation
  };
};

//composition のエクスポート
export default useComment;

//composition を注入するためのキー
export const USE_COMMENT_KEY = Symbol('useComment');
